import { MutationOptions, useMutation } from '@tanstack/react-query';

export interface ServerActionReturn<Data = unknown> {
  status?: number;
  error?: string;
  success: boolean;
  data?: Data;
}

type ActionType<Data, Args> = (args: Args) => Promise<ServerActionReturn<Data>>;
type OptionsType<Data, Args> = Omit<
  MutationOptions<ServerActionReturn<Data>, Error, Args>,
  'mutationFn'
>;

export function useServerActionMutation<Data = unknown, Args = unknown>(
  action: ActionType<Data, Args>,
  options?: OptionsType<Data, Args>,
) {
  const mutationFn = async (args: Args) => {
    const response = await action(args);
    const { error } = response;

    if (error) throw new Error(error);

    return response;
  };

  return useMutation({
    mutationFn,
    ...options,
  });
}
